import React from 'react';

import { Row, Col, Alert } from 'reactstrap';

/**
 * Bloco exibido no login quando o e-mail pertence a um subscriber com SSO.
 * Substitui o campo de senha e o botão "Fazer login".
 * O botão é type="submit" para o AvForm validar o e-mail e o Enter funcionar.
 */
const EntraIdSsoNotice = ({ loading, error }) => (
  <>
    {error && (
      <Row className="w-100">
        <Col className="px-0">
          <Alert color="danger">{error}</Alert>
        </Col>
      </Row>
    )}

    <Row>
      <Col className="text-left">
        <Alert color="info" className="mb-0">
          <strong>Sua empresa usa o login corporativo da Microsoft.</strong>
          <div className="d-block mt-1">
            Você será direcionado para a página de login da sua empresa e, ao
            concluir, voltará automaticamente para o Viddy.
          </div>
        </Alert>
      </Col>
    </Row>

    <Row className="my-4">
      <Col>
        <button
          className="new-layout-auth-btn btn btn-primary btn-block waves-effect waves-light"
          type="submit"
          disabled={loading}
        >
          {loading
            ? 'Redirecionando para o login da Microsoft...'
            : 'Continuar com a Microsoft'}
        </button>
      </Col>
    </Row>
  </>
);

export default EntraIdSsoNotice;
